import * as React from 'react';
import store from "../../../storeWire";
import { system_notification } from "../../../store/slice/system";
import { useState, useEffect } from "react";
import { useCartStore } from "../../../hooks/cart";
import { useForm } from 'react-hook-form';
import useReduxState from 'src/hooks/useReduxState';
import ReusableDiv from 'src/support/ReusableDiv';
import CartRepository from 'src/repository/CartRepository';
import { useOrderStore } from 'src/hooks/order';
import { useAxiosIndicatorCheck } from 'src/store/hook/useAxiosIndicatorCheck';
import {stepEventMaker} from "src/support/stepEventMaker";
import { useSelector } from "react-redux";

const StepShippingAddress = (props) => {
    const [{ WEB_ORDER_ID }, { get_selected_shipping_address, get_cart_quote_number }, { }] = useCartStore();
    const [{ }, { fetch_place_order_items }, { place_your_order }] = useOrderStore();
    const selectedAddress = get_selected_shipping_address()
    const [shippingAddress, setShippingAddress] = useState(selectedAddress);
    const [isEdit, setIsEdit] = useState(false);
    const [isFieldsDisable, setIsFieldDisable] = useState(false);
    const [shippingAddressInfo, setShippingAddressInfo] = useReduxState({}, 'setShippingAddressInfo')
    const [checkOutStepStatus, setCheckoutStepStatus] = useReduxState('step1', 'setCheckoutStepStatus')
    const numericPattern = /^[0-9-+()\/]*$/
    const { register, setValue, handleSubmit, formState: { errors } } = useForm({
        mode: "onChange"
    });
    const [shippingInfoError, setShippingInfoError] = useReduxState(false, 'setShippingInfoError')
    const quoteNumber = get_cart_quote_number();
    const [__check] = useAxiosIndicatorCheck();
    const [carrierStepComplete] = useReduxState('', "setCarrierStepComplete");

    useEffect(() => {
        async function fetchHere() {
            const detail = await fetch_place_order_items(WEB_ORDER_ID);
            if (detail && Object.entries(detail.payload).length > 0) {
                let shippingAddressData = {
                    ATTN: detail.payload.attn,
                    telephoneNumber: detail.payload.telephoneNumber,
                    SDICode: '', //data.SDICode,
                    PECEmail: '',//data.PECEmail,
                    shippingAddress: shippingAddress,
                }
                setShippingAddressInfo(shippingAddressData)
                setCheckoutStepStatus(!carrierStepComplete ? 'step2' : 'step3')
                setValue('attn', detail.payload.attn);
                setValue('phone', detail.payload.telephoneNumber);
                setIsFieldDisable(false);
            }
        }

        if (__check(['VIEW_CART_API_CALL']).status) {
            setIsFieldDisable(true)
        } else if (!quoteNumber && WEB_ORDER_ID && !__check(['VIEW_CART_API_CALL']).status) {
            fetchHere()
        } else {
            setIsFieldDisable(false)
        }

    }, [WEB_ORDER_ID, __check(['VIEW_CART_API_CALL']).status]);


    useEffect(() => {
        if (Object.keys(errors).length > 0) {
            setShippingInfoError(true)
        } else {
            setShippingInfoError(false)
        }
    }, [Object.keys(errors).length]);

    /**
     * CR #      : 8982
     * Change #  : Passing empty in SDI Code & PEC Email
     * Change by : Pankaj
     * Date      : 28 March 2023 
     */
    const onSubmit = async (data) => {
        let shippingAddressData = {
            ATTN: data.attn,
            telephoneNumber: data.phone,
            SDICode: '', //data.SDICode,
            PECEmail: '',//data.PECEmail,
            shippingAddress: shippingAddress,
        }

        if (!quoteNumber) {
            let params = {
                ATTN: data.attn,
                telephoneNumber: data.phone,
                SDICode: '', //data.SDICode,
                PECEmail: '',//data.PECEmail,
                shippingAddress: shippingAddress,
                cartId: await new CartRepository().getCartID(),
                orderPlaced: false
            }
            await place_your_order(params)
        }

        setShippingAddressInfo(shippingAddressData)
        setCheckoutStepStatus(!carrierStepComplete ? 'step2' : 'step3')
        setIsEdit(false);
        checkOutStep1();

    }
    

    //By Ramya Kannan [Cart, quote Checkout-step1 ] 
    let CART_DATA = useSelector((state) => state.entities.Cart.CART_DATA);
    let quoteDetails = useSelector(
        (state) => state.entities.model_QuoteDetail.cart_quote_active_session
      );

    function checkOutStep1(){
        localStorage.setItem("adobeEventType","checkOut");
        let checkOutStep = "checkoutStep1";
        stepEventMaker(CART_DATA,quoteDetails,checkOutStep,quoteNumber);
    }

    return (
        <>
            <div className={"shipping-address steps-inner mb-3 active " + (((checkOutStepStatus.toLowerCase() !== 'step1') && !isEdit) ? 'completed' : '')}>
                <div className="checkout-titles d-flex justify-content-between">
                    <h1>1. Shipping and VAT</h1>
                    <a onClick={() => setIsEdit(true)}>Change</a>
                </div>

                <div className="shipping-address-detail checkbox-steps-content">
                    <div className="bs5 row">
                        <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                            {shippingAddress !== undefined && shippingAddress.name !== undefined &&
                                shippingAddress.addressLine !== undefined && shippingAddress.cityName !== undefined &&
                                shippingAddress.countrySubDivisionCode !== undefined && shippingAddress.postalCode !== undefined &&
                                shippingAddress.countryCode !== undefined &&
                                <div>
                                    <div className='font-16 font-bold font-apecru'>{shippingAddress.name}</div>
                                    <p className='mb-0'>{shippingAddress.addressLine}<br />
                                        {shippingAddress.cityName + ', '} {shippingAddress.countrySubDivisionCode} {shippingAddress.postalCode}<br />
                                        {shippingAddress.countryCode}
                                    </p>
                                </div>
                            }


                            <div className=" shipping-option step-complete-hide">
                                <a className='text-blue2 me-1' data-toggle="modal" data-target="#addshippaddress"
                                    onClick={() => {
                                        store.dispatch(system_notification({
                                            name: 'AddShippingAddressPopup',
                                            data: [],
                                        }));
                                    }}>Add Shipping Address </a>
                                <span className='text-blue2'>|</span>
                                <a className='text-blue2 ms-1' data-toggle="modal" data-target="#changeshippaddress"
                                    onClick={() => {
                                        store.dispatch(system_notification({
                                            name: 'ChangeShippingAddressPopup',
                                            data: [],
                                        }));
                                    }}>Change Shipping Address</a>
                            </div>
                        </div>
                        <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                            <div className="shipping-additional-info step-complete-hide info-text">
                                <form id="hook-form">
                                    <div className="form">
                                        <div className="mb-2">
                                            (*) Required
                                        </div>
                                        <div className="mb-3">
                                            <label htmlFor="attn" className="form-label">ATTN*</label>
                                            <input type="text" disabled={isFieldsDisable} className={"form-control " + (errors.attn?.type === 'required' ? 'error' : '')} id="attn" placeholder="Attention"
                                                {...register('attn', {
                                                    onChange: (e) => { setShippingAddressInfo({ ...shippingAddressInfo, 'ATTN': e.target.value }) },
                                                    required: true
                                                })}
                                            />
                                            <p className="error">{errors.attn?.type === 'required' && "This field is required"}</p>
                                        </div>
                                        <div className="mb-3">
                                            <label htmlFor="ph-no" className="form-label">Phone Number*</label>
                                            <input type="text" disabled={isFieldsDisable} className={"form-control " + (errors.phone?.type === 'required' || errors.phone?.type === 'pattern' ? 'error' : '')} id="ph-no" placeholder="Phone number"
                                                {...register('phone', {
                                                    onChange: (e) => { setShippingAddressInfo({ ...shippingAddressInfo, 'telephoneNumber': e.target.value }) },
                                                    required: true,
                                                    pattern: numericPattern
                                                })} maxLength={32} />
                                            <p className="error">{errors.phone?.type === 'required' && "This field is required"}</p>
                                            <p className="error">{errors.phone?.type === 'pattern' && "A valid phone number is required"}</p>
                                        </div>
                                    </div>
                                </form>
                            </div>
                            <div className="step-complete-show">
                                <div className="info-text">
                                    <p className="mb-2">ATTN: {shippingAddressInfo.ATTN}</p>
                                    <p className="mb-2">Phone Number: {shippingAddressInfo.telephoneNumber}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {(checkOutStepStatus.toLowerCase() === 'step1' || isEdit) &&
                    <div className="shipping-method-detail checkbox-steps-content pt-0">
                        <div className="bs5 row">
                            <div className="col-12 col-sm-12 d-flex align-items-end flex-wrap">
                                <button type="button" disabled={isFieldsDisable} className="bs5 btn btn-primary btn-sm mt-auto d-block ms-auto w100"
                                    form="hook-form" onClick={handleSubmit(onSubmit)}>Continue</button>
                            </div>
                        </div>
                    </div>
                }
                 {/* <div className="shipping-method-detail checkbox-steps-content pt-0">
                    <div className="bs5 row">
                        {ReusableDiv.ShippingMethodDetailRender()}
                        {(checkOutStepStatus.toLowerCase() === 'step1' || isEdit) &&
                            <div className="col-12 col-sm-12 col-lg-6 col-xl-6 d-flex align-items-start flex-wrap">
                                <button type="button" disabled={isFieldsDisable} className="bs5 btn btn-primary btn-sm mt-auto d-block ms-auto w100"
                                    form="hook-form" onClick={handleSubmit(onSubmit)}>Continue</button>
                            </div>
                        }
                    </div>
                </div> */}
            </div>
        </>
    );
}

export default StepShippingAddress;